type ViewportResolver = () => HTMLElement | null

let pageResolver: ViewportResolver | null = null

/**
 * Lets the page on screen in the detail sheet say which element scrolls, for
 * history scroll snapshots. Returns an unregister function.
 */
export function registerSheetScrollViewport(resolver: ViewportResolver) {
  pageResolver = resolver
  return () => {
    if (pageResolver === resolver) pageResolver = null
  }
}

export function findSheetScrollViewport(): HTMLElement | null {
  if (pageResolver) return pageResolver()
  return document.querySelector<HTMLElement>(
    "[data-slot='detail-sheet-content'] [data-slot='sheet-body']>[data-slot='scroll-area-viewport']"
  )
}
